import { useState, useEffect } from 'react'
import { usuariosService } from '../services/api'
import { useChat } from '../contexts/ChatContext'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import './MotoristasLista.css'

function MotoristasLista() {
    const { openChat } = useChat()
    const { usuario, isLogado } = useAuth()
    const navigate = useNavigate()
    const [motoristas, setMotoristas] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadingPayment, setLoadingPayment] = useState(false)

    const handleSejaMotorista = async () => {
        if (!isLogado) {
            navigate('/login')
            return
        }

        setLoadingPayment(true)
        try {
            const token = localStorage.getItem('token')
            const resp = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/pagamentos/checkout-motorista`, {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            const data = await resp.json()
            if (data.url) {
                window.location.href = data.url
            } else {
                alert('Erro ao gerar link de pagamento. Tente novamente.')
            }
        } catch (error) {
            console.error('Erro ao redirecionar para checkout de motorista:', error)
            alert('Falha na comunicação com o servidor.')
        } finally {
            setLoadingPayment(false)
        }
    }

    useEffect(() => {
        carregarMotoristas()
    }, [])

    const carregarMotoristas = async () => {
        try {
            const response = await usuariosService.listarMotoristas()
            setMotoristas(response.motoristas || [])
        } catch (error) {
            console.error('Erro ao carregar motoristas:', error)
        } finally {
            setLoading(false)
        }
    }

    const apiUrl = import.meta.env.VITE_API_URL || 'https://api.agroov.com';

    if (loading) return <div className="loading" style={{textAlign: 'center', marginTop: '100px', color: 'white'}}>Carregando parceiros da estrada...</div>

    return (
        <div className="motoristas-page">
            <div className="motoristas-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px', marginBottom: '20px' }}>
                <div>
                    <h1 style={{ margin: 0 }}>Encontre Transportadores</h1>
                    <p style={{ margin: '5px 0 0 0' }}>Nossos parceiros verificados para fretes agrícolas</p>
                </div>
                {isLogado && (usuario?.motorista_verificado === true || usuario?.motoristaVerificado === true) ? (
                    <button
                        onClick={() => {
                            if (usuario?.tipo_veiculo || usuario?.tipoVeiculo) {
                                alert('Veículo já foi cadastrado!');
                            } else {
                                navigate('/adicionar-tipo?tipo=motorista&modo=editar');
                            }
                        }}
                        className="btn"
                        style={{
                            backgroundColor: (usuario?.tipo_veiculo || usuario?.tipoVeiculo) ? 'rgba(255,255,255,0.05)' : '#f59e0b',
                            color: (usuario?.tipo_veiculo || usuario?.tipoVeiculo) ? '#94a3b8' : '#0f172a',
                            border: (usuario?.tipo_veiculo || usuario?.tipoVeiculo) ? '1px solid rgba(255,255,255,0.1)' : 'none',
                            fontWeight: 'bold',
                            padding: '10px 20px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                    >
                        {(usuario?.tipo_veiculo || usuario?.tipoVeiculo) ? '✅ Veículo Cadastrado' : '🚚 Cadastrar Veículo'}
                    </button>
                ) : (
                    <button
                        onClick={handleSejaMotorista}
                        disabled={loadingPayment}
                        className="btn"
                        style={{
                            backgroundColor: '#fbbf24',
                            color: '#0f172a',
                            border: 'none',
                            fontWeight: 'bold',
                            padding: '10px 20px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                    >
                        {loadingPayment ? '⏳ Processando...' : '🚚 Seja Motorista'}
                    </button>
                )}
            </div>

            {isLogado && (usuario?.motorista_verificado === true || usuario?.motoristaVerificado === true) && (!usuario?.tipo_veiculo && !usuario?.tipoVeiculo) && (
                <div className="alert-cadastro-veiculo" style={{
                    backgroundColor: 'rgba(245, 158, 11, 0.1)',
                    border: '1px solid rgba(245, 158, 11, 0.25)',
                    borderRadius: '12px',
                    padding: '1.25rem',
                    marginBottom: '1.5rem',
                    color: '#fbbf24',
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    width: '100%'
                }}>
                    <span style={{ fontSize: '1.25rem' }}>⚠️</span>
                    <div>
                        <strong>Perfil Incompleto:</strong> Seu perfil de motorista está oculto para outros usuários na listagem pública pois você ainda não cadastrou seu veículo. Clique no botão acima para cadastrar!
                    </div>
                </div>
            )}

            {motoristas.length === 0 ? (
                <div className="empty-state" style={{textAlign: 'center', marginTop: '50px', color: '#94a3b8'}}>
                    <div style={{fontSize: '50px', marginBottom: '15px'}}>🚚</div>
                    <h3>Nenhum motorista cadastrado ainda.</h3>
                    <p>Seja o primeiro a se juntar à nossa frota!</p>
                </div>
            ) : (
                <div className="motoristas-grid">
                    {motoristas.map(m => (
                        <div key={m.id} className="motorista-card">
                            
                            <div className="motorista-card-header">
                                <div className="motorista-avatar">
                                    {m.foto_perfil ? (
                                        <img src={m.foto_perfil.startsWith('http') ? m.foto_perfil : `${apiUrl.replace(/\/$/, '')}/${m.foto_perfil.replace(/^\//, '')}`} alt={m.nome} />
                                    ) : (
                                        <div className="avatar-placeholder">{m.nome.charAt(0).toUpperCase()}</div>
                                    )}
                                </div>
                                <div className="motorista-info-top">
                                    <h3>
                                        {m.nome}
                                        <span className="motorista-verificado-badge" title="Motorista Verificado">✓</span>
                                    </h3>
                                    {isLogado ? (
                                        <>
                                            <p className="location">📍 {m.cidade || 'Local não informado'} {m.estado ? `- ${m.estado}` : ''}</p>
                                            <p className="telefone-detalhe" style={{ margin: '4px 0 0', color: '#94a3b8', fontSize: '0.9rem' }}>📞 {m.telefone || 'Não informado'}</p>
                                        </>
                                    ) : (
                                        <p className="location-locked">📍 Localização Bloqueada</p>
                                    )}
                                </div>
                            </div>

                            {m.foto_veiculo && (
                                <div className={`motorista-foto-veiculo ${!isLogado ? 'blur-img' : ''}`}>
                                    <img src={m.foto_veiculo.startsWith('http') ? m.foto_veiculo : `${apiUrl.replace(/\/$/, '')}/${m.foto_veiculo.replace(/^\//, '')}`} alt="Veículo" />
                                    {!isLogado && (
                                        <div className="img-overlay-locked">
                                            <span>🔒 Bloqueado</span>
                                        </div>
                                    )}
                                </div>
                            )}

                            {isLogado ? (
                                <>
                                    <div className="caminhao-info">
                                        <span className="info-tag">🚛 {m.tipo_veiculo || 'Veículo não informado'}</span>
                                        {m.capacidade_gado && <span className="info-tag">🐄 {m.capacidade_gado} cab.</span>}
                                        {m.capacidade_peso && <span className="info-tag">⚖️ {m.capacidade_peso} kg</span>}
                                    </div>

                                    <div style={{ display: 'flex', gap: '10px', marginTop: '1rem' }}>
                                        <button 
                                            className="btn btn-outline btn-chamar" 
                                            style={{ flex: 1, padding: '0.5rem', fontSize: '0.9rem' }} 
                                            onClick={() => openChat({ id: m.id, nome: m.nome, foto: m.foto_perfil }, 'Olá! Gostaria de fazer uma cotação de frete com você. Está disponível?')}
                                        >
                                            Chat Interno
                                        </button>
                                        <button 
                                            className="btn" 
                                            style={{ flex: 1, backgroundColor: '#25D366', color: 'white', border: 'none', fontWeight: 'bold', padding: '0.5rem', fontSize: '0.9rem' }} 
                                            onClick={() => {
                                                const tel = (m.telefone || '').replace(/\D/g, '');
                                                if(tel) {
                                                    window.open(`https://wa.me/55${tel}?text=${encodeURIComponent('Olá! Encontrei você na Compre Agro e gostaria de fazer uma cotação de frete. Está disponível?')}`, '_blank');
                                                } else {
                                                    alert('Este motorista não possui telefone cadastrado.');
                                                }
                                            }}
                                        >
                                            WhatsApp
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <div className="motorista-locked-actions">
                                    <button 
                                        className="btn btn-primary btn-block"
                                        onClick={() => navigate('/login')}
                                        style={{ marginTop: '1rem' }}
                                    >
                                        Fazer login para ver detalhes
                                    </button>
                                </div>
                            )}
                            
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default MotoristasLista
